import { Injectable } from "@angular/core";
import { UserType } from "@app/enum/UserType";
import { IUser } from "@app/interfaces/IUser";
import { DataCacheService } from "@app/services/caching/data-cache.service";
import { LoginHistoryService } from "@app/services/login-history.service";
import { ResellerUserGroupMappingService } from "@app/services/resellerUserGroupMapping.service";
import { combineLatest, Observable } from "rxjs";
import { map, mergeMap, tap } from "rxjs/operators";
import { UserService } from "./user.service";
import { FoundationUserResellerMappingService } from "./userResellerMapping.service";

@Injectable({
    providedIn: 'root'
})
export class EngineerService {

    private engineerCacheName: string = "foundationEngineerCache";
    constructor(
        private readonly dataCacheService: DataCacheService,
        private readonly loginHistoryService: LoginHistoryService,
        private readonly userService: UserService,
        private readonly userResellerMappingService: FoundationUserResellerMappingService,
        private readonly resellerUserGroupMappingService: ResellerUserGroupMappingService
    ) { }


    getEngineersWithMappings(): Observable<IUser[]> {
        return combineLatest([
            this.getEngineers(),
            this.loginHistoryService.getLatestLoginHistories()
        ]).pipe(
            map(([engineers, loginHistory]) => {
                engineers.forEach(engineer => {
                    const engineerLoginHistory = loginHistory.find(history => history.UserId === engineer.Id);
                    engineer.lastLoggedIn = engineerLoginHistory?.CreatedTime;
                });

                return engineers;
            }))
    }

    getEngineers(invalidateCache = false): Observable<IUser[]> {
        return this.dataCacheService.getOrRequest(this.engineerCacheName, () => this.getEngineersFromDb(), { invalidateCache });
    }

    getEngineersFromDb(): Observable<IUser[]> {
        return this.userService.getUsers({ Type: UserType.Engineer });
    }

    getEngineersForAccount(accountId: number): Observable<IUser[]> {
        return this.userService.getUsersForAccount(accountId).pipe(map(users => users.filter(user => user.Type === UserType.Engineer)));
    }

    engineerSearchPredicate(engineer: IUser, value?: any): boolean {
        return engineer.Email.toLowerCase().includes(value.toLowerCase());
    }

    saveEngineer(engineer: IUser): Observable<any> {
        return this.userService.saveUser(engineer).pipe(
            tap(userId => {
                this.dataCacheService.addOrUpdateItem(engineer, this.engineerCacheName);
            })
        ); 
    }

    addCsvImportedEngineersToCache(engineers: IUser[]): void {
        engineers.forEach(e => {
            this.dataCacheService.addOrUpdateItem(e, this.engineerCacheName);
        })
    }

}
